import styled from 'styled-components'
import media from 'styled-media-query'

import { customMedia } from '../../../utils/breakpoints'

export const SocialFooterContainer = styled.div`
  padding-bottom: 45px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  font-size: 1.5rem;
  align-items: center;
  line-height: 1.6rem;
`

export const IconsContainer = styled.div`
  display: flex;
  ${media.lessThan('medium')`
    width: 100%
  `}
`

export const SocialLink = styled.a`
  color: ${props => props.theme.footer.desktop.social.icon};
  margin-left: 90px;
  padding: 0 5px;

  ${customMedia.lessThan('md')`
      margin-left: 30px;
  `}

  ${customMedia.lessThan('sm')`
  color: ${props => props.theme.footer.mobile.social.icon};
  margin-left: 0px;
  padding-right: 30px;
  `}
`
